import { render, staticRenderFns } from "./helpPayForFaile.vue?vue&type=template&id=33cbbf72&"
import script from "./helpPayForFaile.vue?vue&type=script&lang=js&"
export * from "./helpPayForFaile.vue?vue&type=script&lang=js&"
import style0 from "./helpPayForFaile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports